export default __webpack_public_path__ + "static/back-1b2c6e104000ce63c56dc4ad63e74c30.webp";